import React from 'react';
import PropTypes from 'prop-types';
import Message from 'components/Message';
import Confirm from 'components/Confirm';
import { disableServiceModalMessages as messages } from './ClassList.messages';

const DisableServiceConfirmationModal = ({ classTitle, numberOfReservations }) => {
  return (
    <Confirm
      title={
        <Message
          message={!numberOfReservations ? messages.title : messages.titleWithReservations}
          values={{ classTitle, numberOfReservations }}
        />
      }
      cancelNode={<Message message={messages.cancel} />}
      acceptNode={<Message message={messages.accept} />}
      isOpen>
      <Message
        message={messages.body}
        values={{
          strong: text => <strong>{text}</strong>,
        }}
      />
    </Confirm>
  );
};

DisableServiceConfirmationModal.propTypes = {
  classTitle: PropTypes.string,
  numberOfReservations: PropTypes.number,
};

export default DisableServiceConfirmationModal;
